module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring@2x.143555f.jpg";